(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-nav-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  var main = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.style.opacity = '0';
      setTimeout(function () {
        main.src = t.getAttribute('data-full');
        main.srcset = '';
        main.style.opacity = '1';
      }, 150);
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });
  if (main) main.style.transition = 'opacity 0.15s ease';
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var form = wrap.closest('form');
    wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value || '0', 10) + parseInt(btn.getAttribute('data-step'), 10);
        input.value = Math.max(0, v);
        if (form) form.submit();
      });
    });
  });
})();
